import { render, staticRenderFns } from "./amap.vue?vue&type=template&id=61b1ff3c&"
import script from "./amap.vue?vue&type=script&lang=js&"
export * from "./amap.vue?vue&type=script&lang=js&"
import style0 from "./amap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports